// React
import React from 'react';

// Packages

// Utilities
import { useLabels, useActivityTagging } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ActivityMetrics,
    ActivityReflections,
    ActivityDetails,
    ActivityChoice,
    ActivityDataCard,
    ActivitySetFieldValues,
} from '../_common';
import { ActivityUpgradeDetails } from 'components/_cardContents/activityUpgrade/activityUpgrade';

const Name = CONSTANTS.ACTIVITIES.UPGRADE;

const Choice = props => {
    return ActivityChoice({
        Name,
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ActivityDataCard
            {...{
                item,
                theme,
                tagTypes: [CONSTANTS.TAGS.UPGRADE_ACTIVITY],
                showTags: mode.includes('tags'),
                showDetails: mode.includes('details'),
            }}>
            <ActivityUpgradeDetails {...{ item, theme }} />
        </ActivityDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, dataSet, label } = useLabels();
    const tagging = useActivityTagging({
        types: [CONSTANTS.TAGS.UPGRADE_ACTIVITY],
    });

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { Initiative_Location__c } = formData;

        // Data for sf
        return {
            Initiative_Location__c: Initiative_Location__c.map(
                item => item.selectValue
            ).join(';'),
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'SelectList',
                name: 'Initiative_Location__c',
                object: object.config(
                    'Initiative_Activity__c.Initiative_Location__c'
                ),
                buttonLabel: label('ButtonAddLocation'),
                listMaxLength: 8,
                options: dataSet('Countries'),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ActivityDetails({
        tagging: tagging.activity,
        fields,
        getItemData,
        ...props,
    });
};

const Metrics = props => {
    return ActivityMetrics({
        Name,
        additional: true,
        ...props,
    });
};

const Reflections = props => {
    return ActivityReflections({
        additional: true,
        ...props,
    });
};

const setFieldValues = ({
    tagging,
    choice,
    form,
    id,
    utilities,
    REPORT_ID,
}) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const { Initiative_Location__c } = utilities.activities.get(id);

    // Country
    form.setValue(
        'Initiative_Location__c',
        Initiative_Location__c?.split(';').map(value => ({
            selectValue: value,
        }))
    );

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ActivitySetFieldValues({
        REPORT_ID,
        tagging,
        choice,
        form,
        id,
        utilities,
    });
};

export {
    Name,
    DataCard,
    Choice,
    Details,
    Metrics,
    Reflections,
    setFieldValues,
};
